export const BUSINESS = {
  name: "Lavandería Ozono",
  nif: "Y3002686G",
  address: "C. de María Zayas Sotomayor, 18, 50018 Zaragoza (España)",
  email: "lavanderia.actur@gmail.com",
  phone: "628 76 96 27",
  phoneTel: "+34628769627",
  hours: "Todos los días de 7:30 a 22:30",
  get domain() {
    return window.location.host;
  },
};

export const LEGAL_UPDATED = "1 de junio de 2026";

export const LEGAL_PAGES = [
  { to: "/aviso-legal", label: "Aviso legal" },
  { to: "/privacidad", label: "Política de privacidad" },
  { to: "/cookies", label: "Política de cookies" },
  { to: "/condiciones", label: "Condiciones del servicio" },
];

export const COOKIE_CONSENT_KEY = "ozono_cookie_consent";
